import "./style.scss";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Armenia from "../../../assets/Armenia.svg";
import Other from "../../../assets/Language.svg";
import { KYC_Step } from "entities/account";
import TermsCheckbox from "pages/onboarding/components/terms-checkbox";
import { VerificationBtn } from "../components/button";
import { useVerificationStep } from "hooks/useVerificationStep";

export const IdentityVerificationPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("app");
  const { t: o } = useTranslation("onboarding-auth");
  // const { kyc, isLoading, onSubmit } =
  //   useVerificationStep<KYC_Step.DocumentNumber>({
  //     step: KYC_Step.DocumentNumber,
  //     navigateOnSuccess: PATH_LIST.selfieWithDocument,
  //   });

  // const [verificationNumber, setVerificationNumber] = useState(
  //   kyc?.national_id || ""
  // );

  // const [isUsaCitizen, setIsUsaCitizen] = useState<boolean | undefined>(
  //   kyc?.has_american_citizenship
  // );
  // const [isPoliticalFigure, setIsPoliticalFigure] = useState<
  //   boolean | undefined
  // >(kyc?.is_political_figure);

  // const [showInvalidMessage, setShowInvalidMessage] = useState(false);

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     if (verificationNumber.length > 0 && verificationNumber.length !== 9) {
  //       setShowInvalidMessage(true);
  //     } else {
  //       setShowInvalidMessage(false);
  //     }
  //   }, 2000);

  //   return () => {
  //     clearTimeout(timeout);
  //     setShowInvalidMessage(false);
  //   };
  // }, [verificationNumber]);

  return (
    <div className="identity-verification">
      <p className="identity-verification-title">{t("enterIDorpassport")}</p>
      {/* <div className="identity-verification-main">
        <div className="identity-verification-field-wrapper">
          <label htmlFor="num">ID/passport number</label>
          <input
            id="num"
            type="text"
            maxLength={9}
            placeholder="ID/passport number"
            value={verificationNumber}
            onChange={(e) =>
              setVerificationNumber(
                e.target.value.toUpperCase().replace(/\s/g, "")
              )
            }
          />
          {showInvalidMessage && <span>{t("invalidIDorpassport")}</span>}
        </div>

        <div className="has-usa-checkbox">
          <p>{o("isPoliticalFigure")}</p>

          <div className="checkbox-wrapper">
            <TermsCheckbox
              term={o("yes")}
              htmlForId="3"
              isChecked={isPoliticalFigure == true}
              onChange={() => setIsPoliticalFigure(true)}
            />
            <TermsCheckbox
              term={o("no")}
              htmlForId="4"
              isChecked={isPoliticalFigure == false}
              onChange={() => setIsPoliticalFigure(false)}
            />
          </div>
        </div>

        <VerificationBtn
          type="submit"
          disabled={
            verificationNumber.length !== 9 ||
            isPoliticalFigure === undefined ||
            isLoading
          }
          text={t("Request")}
          onClick={() =>
            onSubmit({
              document_number: verificationNumber,
              is_political_figure: isPoliticalFigure!,
            })
          }
        />
      </div> */}
    </div>
  );
};
